import React, { useContext } from "react";
import styled from "styled-components";
import { CartContext } from "../CartContext";
import { FaTrash } from "react-icons/fa";
import { getProductData } from "./data/printsData";

const CartProduct = (props) => {
  const cart = useContext(CartContext);
  const id = props.id;
  const quantity = props.quantity;
  const printsData = getProductData(id);
  const canvasType = props.canvasType; // Get from props
  const selectedSize = props.selectedSize; // Get from props
  const price = props.price; // Get from props

  return (
    <Container>
      <img src={printsData.image} alt="" />
      <span>
        <h2>
          <span className="cartPSpan">
            <h4>{printsData.category}</h4>
            <h3>{printsData.title}</h3>
            <h4>
              {canvasType} / {selectedSize}
            </h4>
          </span>
          <FaTrash
            onClick={() => cart.deleteFromCart(id)}
            className="deleteIcon"
          />
        </h2>
        <div className="quantity">
          <h3>€{(price * quantity).toFixed(2)}</h3>
        </div>
      </span>
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  img {
    width: 150px;
  }
  span {
    display: flex;
    flex-direction: column;
    gap: 4px;
    h2 {
      width: 100%;
      display: flex;
      justify-content: space-between;
      span {
        width: 100%;
        text-align: left;
        h4 {
          text-align: left;
          width: 100%;
          font-size: 16px;
          font-weight: 200;
          color: #b9b9b9;
          text-transform: uppercase;
        }
        h3 {
          font-size: 17px;
          font-weight: 400;
          width: 100%;
        }
      }
      .icon {
        font-size: 1em;
        color: white;
        cursor: pointer;
      }
    }
    .quantity {
      display: flex;
      justify-content: center;
      align-items: center;
      h3 {
        text-align: start;
        justify-self: start;
      }
      span {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
        button {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          width: 30px;
          height: 30px;
          border: none;
          color: black;
          margin: 0;
          margin-top: 0;
          border-radius: 8px;
          cursor: pointer;
        }
        h1 {
          font-weight: 300;
        }
      }
    }
  }
`;

export default CartProduct;
